import { array, flow, pipeable, tagged } from '@code-expert/prelude';
const ADT_SINGLETON = tagged.build();
export const publicationEventAdt = () => ADT_SINGLETON;
/**
 * Effectfully transform a publication event.
 */
export const traversePublicationEvent = (F) => (f) => {
    const adtB = publicationEventAdt().wide;
    return publicationEventAdt().fold({
        initial: flow(array.traverse(F)(f), pipeable.map(F)(adtB.initial)),
        insert: flow(f, pipeable.map(F)(adtB.insert)),
        update: flow(f, pipeable.map(F)(adtB.update)),
        delete: flow((id) => adtB.delete(id), F.of),
    });
};
//# sourceMappingURL=PublicationEvent.js.map